/**
 * Whether a floating surface — a popover, a menu, a listbox, another dialog —
 * is open above `element`.
 *
 * Floating surfaces are portaled to the end of the body, so one that opened
 * after the element follows it in document order; that is the "above". The
 * element's own descendants do not count, and neither does anything that
 * contains it.
 *
 * Escape closes the topmost surface. A dialog that handled Escape itself while
 * a filter popover floated over it closed the whole dialog — selection, form
 * state and all — when the user only meant to close the popover.
 */
export function hasFloatingSurfaceAbove(element: Element | null): boolean {
  if (!element) return false;
  const surfaces = document.querySelectorAll(
    '[role="dialog"],[role="menu"],[role="listbox"]',
  );
  return Array.from(surfaces).some(
    (surface) =>
      surface !== element &&
      !element.contains(surface) &&
      !surface.contains(element) &&
      Boolean(
        element.compareDocumentPosition(surface) &
        Node.DOCUMENT_POSITION_FOLLOWING,
      ),
  );
}
